module.exports = __webpack_public_path__ + "img/Camera&lens8.1b949dd5.png";